module.exports = __webpack_public_path__ + "static/img/7.0f36b124.png";